import React from 'react';
import styles from './LanguageSelect.styles.scss';
import cn from 'classnames';
import { Button } from 'primereact/button';

const LanguageSelect = ({ onLangClick, currentLanguage, className }) => {
  return (
    <div className="d-flex align-items-center gap-2 justify-content-end">
      {currentLanguage && (
        <>
          <Button
            link
            className={cn(
              styles.changeLang,
              className,
              currentLanguage !== 'ar' && styles.ar,
            )}
            onClick={
              currentLanguage === 'en'
                ? () => onLangClick('ar')
                : () => onLangClick('en')
            }
          >
            {currentLanguage === 'en' ? 'العربية' : 'English'}
          </Button>
          <i className="pi pi-globe" />
        </>
      )}
    </div>
  );
};

export default React.memo(LanguageSelect);
